export default __webpack_public_path__ + "static/media/baby-30.7791d395.svg";